import {
  RadioTower, Globe, Landmark, TrainFront, Building2, Database, Cpu, HardHat, GraduationCap, Factory, Camera,
} from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const INDUSTRIES = [
  { icon: RadioTower, label: "Telecom Operators" },
  { icon: Globe, label: "Internet Service Providers" },
  { icon: Landmark, label: "Government Organizations" },
  { icon: TrainFront, label: "Railways & Transportation" },
  { icon: Building2, label: "Enterprises" },
  { icon: Database, label: "Data Centers" },
  { icon: Cpu, label: "System Integrators" },
  { icon: HardHat, label: "Infrastructure Companies" },
  { icon: GraduationCap, label: "Educational Institutions" },
  { icon: Factory, label: "Industrial Organizations" },
  { icon: Camera, label: "Security & Surveillance Networks" },
];

export default function Industries() {
  return (
    <section id="industries" data-testid="industries-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHead
          eyebrow="Industries We Serve"
          title="Infrastructure Solutions Across Industries"
          sub="JAYTRIKA supports organizations that depend on reliable telecom and network infrastructure."
        />

        <div className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.label} delay={(i % 4) * 0.06}>
              <div
                data-testid={`industry-card-${i}`}
                className={`group flex h-full flex-col items-center gap-4 rounded-2xl border border-slate-200 bg-slate-50 p-7 text-center transition-all duration-300 hover:-translate-y-1 hover:border-cyan-400/50 hover:bg-navy hover:shadow-xl hover:shadow-navy/25 ${
                  i === INDUSTRIES.length - 1 ? "sm:col-start-2 lg:col-start-auto" : ""
                }`}
              >
                <span className="inline-flex rounded-xl bg-white p-3 text-electric shadow-sm ring-1 ring-slate-200 transition-all duration-300 group-hover:bg-cyan-400/10 group-hover:text-cyan-300 group-hover:ring-cyan-400/30">
                  <ind.icon size={22} />
                </span>
                <p className="text-sm font-semibold text-slate-700 transition-colors duration-300 group-hover:text-white">
                  {ind.label}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
